<template>
  <v-container>
    <v-btn @click="submit" block>
      Search
      <v-icon right>search</v-icon>
    </v-btn>

    <v-select
      v-show="!filter.hideLimit"
      :items="filterOptions.limit"
      v-model="limit"
      label="Limit"
    ></v-select>
    <v-select
      :items="filterOptions.categories"
      v-model="categories"
      label="Categories"
      chips
      multiple
    >
      <template v-slot:selection="{ item }">
        <!-- <v-chip v-if="index < 3"> -->
        <v-chip pill>
          <v-avatar left :color="categoryColors[item]"></v-avatar>
          <!-- für avatar color lighter: -->
          <!-- class="lighten-2" -->
          {{ item }}
        </v-chip>
        <!-- <span v-if="index === 3" class="grey--text caption"
          >(+{{ categories.length - 3 }} others)</span
        > -->
      </template>
    </v-select>
    <v-select
      :items="filterOptions.payment"
      v-model="payment"
      label="Payment"
      chips
    ></v-select>
    <v-select
      :items="filterOptions.status"
      v-model="status"
      label="Status"
      chips
      multiple
    ></v-select>

    <v-text-field
      v-model="price[0]"
      label="min Price"
      type="number"
      append-icon="euro"
      clearable
      :step="price[0] < 1000000 ? 100000 : 250000"
    ></v-text-field>
    <v-text-field
      v-model="price[1]"
      label="max Price"
      type="number"
      append-icon="euro"
      clearable
      :step="price[1] < 1000000 ? 100000 : 250000"
    ></v-text-field>

    <v-text-field
      v-model="bedrooms"
      label="min Bedrooms"
      type="number"
      clearable
      :step="1"
    ></v-text-field>

    <v-text-field
      v-model="bathrooms"
      label="min Bathrooms"
      type="number"
      clearable
      :step="1"
    ></v-text-field>

    <v-text-field
      v-model="living"
      label="min Living Area"
      type="number"
      clearable
      :step="50"
    ></v-text-field>

    <v-text-field
      v-model="terrace"
      label="min Terrace Area"
      type="number"
      clearable
      :step="50"
    ></v-text-field>

    <v-text-field
      v-model="property"
      label="min Property Area"
      type="number"
      clearable
      :step="500"
    ></v-text-field>

    <v-switch
      v-for="prop in filterOptions.properties"
      :key="prop.name"
      :label="prop.label"
      v-model="prop.value"
    ></v-switch>

    <v-divider></v-divider>
    <v-switch
      label="Show Customers"
      v-model="showCustomers"
      color="teal"
    ></v-switch>
  </v-container>
</template>

<script>
export default {
  name: 'ImmoFilter',
  props: ['filter'],
  data() {
    return {
      drawer: true,
      favourites: false,
      filterOptions: {
        limit: ['10', '25', '50', '100', '250', '500', '1000'],
        categories: [
          'VILLA',
          'APARTMENT',
          'FINCA',
          'PENTHOUSE',
          'COMMUNITY',
          'BUSINESS',
          'PLOT'
        ],
        payment: ['BUY', 'RENT'],
        status: ['INPROGRESS', 'AUTHORISED', 'CONTACT', 'UNKNOWN', 'SOLD'],
        properties: [
          { label: 'Pool', name: 'pool', value: false },
          { label: 'Parking', name: 'parking', value: false },
          { label: 'Garage', name: 'garage', value: false },
          { label: 'Sea View', name: 'sea_view', value: false },
          { label: 'Sea Access', name: 'sea_access', value: false },
          { label: 'Golf', name: 'golf', value: false },
          // { label: 'Kitchen', name: 'kitchen', value: false }
          { label: 'Rental Licence', name: 'rental', value: false },
          { label: 'Investment', name: 'investment', value: false }
        ]
      },

      limit: this.filter.limit,
      categories: this.filter.categories,
      payment: this.filter.payment,
      status: this.filter.status,
      price: [null, null],
      bedrooms: null,
      bathrooms: null,
      living: null,
      terrace: null,
      property: null,

      showCustomers: this.filter.showCustomers,

      categoryColors: {
        VILLA: 'blue',
        APARTMENT: 'orange',
        FINCA: 'green',
        PENTHOUSE: 'purple',
        COMMUNITY: 'yellow',
        BUSINESS: 'grey',
        PLOT: 'red'
      }
    }
  },
  computed: {
    currentFilter() {
      let f = {
        limit: this.limit,
        categories: this.categories,
        payment: this.payment,
        status: this.status,
        showCustomers: this.showCustomers
      }
      if (this.price[0]) f.price__gte = this.price[0]
      if (this.price[1]) f.price__lte = this.price[1]
      if (this.bedrooms) f.bedrooms__gte = this.bedrooms
      if (this.bathrooms) f.bathrooms__gte = this.bathrooms
      if (this.living) f.living__gte = this.living
      if (this.terrace) f.terrace__gte = this.terrace
      if (this.property) f.property__gte = this.property

      this.filterOptions.properties.forEach(v => {
        if (v.value) f[v.name] = true
        else delete f[v.name]
      })
      return f
    }
  },
  watch: {
    'filter.page': {
      handler() {
        this.$emit('filterUpdated', this.currentFilter)
      }
    }

    // for dev for now
    /* currentFilter: {
      handler() {
        this.$emit('filterUpdated', this.currentFilter)
      },
      deep: true,
      immediate: true
    } */
  },

  methods: {
    submit() {
      this.$emit('filterUpdated', this.currentFilter)
    }
  }
}
</script>

<style></style>
,
